<!-- <div class="flex md:hidden">
  <div class="layout-main-container px-3 pt-3 w-full">
    <p-button [text]="true" severity="secondary" (click)="toogleSidebar()">
      <i class="pi pi-bars" style="font-size: 2.5rem"></i>
    </p-button>
  </div>
</div>
<div class="layout-sidebar h-full">
  <div class="flex md:hidden">
    <p-sidebar [(visible)]="displaySidebar">
      <app-profile></app-profile>
      <app-menu></app-menu>
    </p-sidebar>
  </div>

  <div class="hidden md:flex">
    <div class="min-h-screen w-18rem xl:w-22rem px-3 py-6">
      <app-profile></app-profile>
      <app-menu></app-menu>
    </div>
  </div>
</div>
<div class="hidden md:flex">
  <div class="fixed bottom-0 ml-7 mb-5">
    <img [src]="srcLogo" class="flex h-3rem cursor-pointer" routerLink="/inicio">
  </div>
</div> -->



<aside class="dashboard__sidebar" [ngClass]="{ 'open': isOpen }">
  <div class="dashboard__sidebarClose">
    <i class="pi pi-times" (click)="sidebarClose()"></i>
  </div>

  <div class="dashboard__sidebarContent">
    <div class="dashboard__sidebarProfile">
      <app-profile></app-profile>
    </div>

    <div class="dashboard__sidebarMenu">
      <p-scrollPanel>
        <app-menu></app-menu>
      </p-scrollPanel>
    </div>

    <div class="dashboard__sidebarFooter">
      <div class="footerMenu">
        <div class="footerMenu__version">
          <span>v3.0.0</span>
        </div>

        <div class="footerMenu__logo">
          <a routerLink="/inicio">
            <svg width="87" height="22" viewBox="0 0 87 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.18392 4.19316H3.73712V11.4776L7.63534 5.47866C8.15308 4.68287 9.03627 4.19316 9.98037 4.19316H12.9649L8.09217 11.3552L13.1781 21.731H9.18854L6.87397 15.579C6.14305 14.3547 5.74714 14.171 5.01622 14.3241C4.31576 14.4465 3.70666 15.0586 3.70666 15.6402V20.4149C3.70666 21.1494 3.24984 21.7616 2.51892 21.7616H0.326172V6.06019C0.326172 5.01955 1.17891 4.19316 2.18392 4.19316Z" fill="white"/>
              <path d="M29.1365 22.0064C25.0555 21.884 23.0151 19.4967 23.0151 14.8444C23.0151 10.2227 25.086 7.89661 29.1974 7.89661C33.4915 7.89661 35.5016 10.5288 35.2579 15.8544H26.5174C26.6392 17.9357 27.5528 18.9763 29.1974 18.9763C29.9892 18.9763 30.7201 18.6397 31.3901 17.9969C31.6947 17.6602 32.0906 17.5072 32.5474 17.5072H35.0447C34.3138 20.4149 32.4561 22.0064 29.1365 22.0064ZM26.5478 13.4365H31.6338C31.4206 11.6307 30.5983 10.7125 29.1365 10.7125C27.6747 10.7125 26.8219 11.6307 26.5478 13.4365Z" fill="white"/>
              <path d="M49.5413 4.77469V15.8544C49.5413 19.9252 47.4094 21.9758 43.2066 21.9452C39.0039 21.8534 36.9329 19.5885 36.9329 15.0587C36.9329 10.437 38.7298 8.08025 42.3234 7.95782C43.9985 7.95782 45.308 8.66179 46.1912 10.0697V3.03009H47.8662C48.7799 3.03009 49.5413 3.82588 49.5413 4.77469ZM40.4352 14.9056C40.4048 17.6602 41.3184 19.0376 43.2675 19.0376C45.2167 19.0376 46.1912 17.6602 46.1912 14.9056C46.0999 12.2734 45.1558 10.9879 43.3285 10.9879C41.5012 10.9879 40.5266 12.2734 40.4352 14.9056Z" fill="white"/>
              <path d="M53.3786 7.71297C54.4749 7.71297 55.0231 8.26389 55.0231 9.36575V21.731H51.6426V7.71297H53.3786Z" fill="white"/>
              <path d="M21.4009 8.14147C19.9696 8.14147 18.7514 8.35571 17.7768 8.81482C17.5636 8.23329 17.0459 7.95782 16.2541 7.95782H14.4572V21.731H17.8986V14.5995C17.9291 12.6713 18.8732 11.6919 20.7309 11.6919H21.8882V8.14147H21.4009Z" fill="white"/>
              <path d="M55.0231 4.74409C55.0231 5.6929 54.2618 6.45808 53.3177 6.45808C52.3736 6.45808 51.6122 5.6929 51.6122 4.74409C51.6122 3.79527 52.3736 3.03009 53.3177 3.03009C54.2618 3.03009 55.0231 3.79527 55.0231 4.74409Z" fill="white"/>
              <path d="M63.2155 21.6392V13.5589L56.1804 0H61.0532L65.256 9.33514L68.5451 1.3161C68.9106 0.459105 69.5197 0 70.3724 0H73.6311L67.266 13.5589V21.6392H63.2155Z" fill="white"/>
              <path d="M83.4984 10.7431C84.5034 10.0391 85.2039 9.6106 85.4171 9.45757C86.3003 8.93725 85.813 8.38632 85.813 8.38632C85.7217 8.38632 85.6303 8.38632 85.5389 8.38632H85.5085C85.478 8.38632 85.4475 8.38632 85.3866 8.38632C85.3562 8.38632 85.3562 8.38632 85.3257 8.38632C85.2953 8.38632 85.2648 8.38632 85.2344 8.38632C85.2039 8.38632 85.2039 8.38632 85.1735 8.38632C85.143 8.38632 85.1125 8.38632 85.0821 8.38632C85.0516 8.38632 85.0516 8.38632 85.0212 8.38632C84.9907 8.38632 84.9603 8.38632 84.9603 8.38632C84.9298 8.38632 84.9298 8.38632 84.8994 8.38632C84.8689 8.38632 84.8385 8.38632 84.8385 8.38632C84.808 8.38632 84.808 8.38632 84.7775 8.38632C84.7471 8.38632 84.7166 8.38632 84.6862 8.38632H84.6557C84.6253 8.38632 84.5644 8.41693 84.5339 8.41693C84.5035 8.41693 84.473 8.41693 84.4426 8.44753H84.4121C84.3816 8.44753 84.3816 8.44753 84.3512 8.44753H84.3207C84.2903 8.44753 84.2903 8.44753 84.2903 8.44753H84.2294C84.2294 8.44753 84.2294 8.44753 84.1989 8.44753H84.1684C84.1684 8.44753 84.1685 8.44753 84.138 8.44753H84.1075C83.8639 8.50875 83.5898 8.56996 83.3462 8.63118C83.2548 8.66178 83.1634 8.69239 83.0721 8.69239C81.7321 9.05968 80.4834 9.54939 79.3261 10.0697C79.2347 10.1309 79.1129 10.1615 79.0216 10.2227C78.8997 10.284 78.7779 10.3452 78.6561 10.4064C78.5648 10.4676 78.4734 10.4982 78.3516 10.5594C78.2298 10.6206 78.1079 10.7125 77.9557 10.7737C76.9506 11.3552 76.037 11.9673 75.2147 12.6101L75.6411 11.1716L77.6816 4.13195L79.1738 9.21271C80.2398 8.69239 81.3666 8.26389 82.6153 7.89661L80.0266 0H76.8288C75.8543 0 75.2147 0.489712 74.9406 1.43853L68.4537 21.6392H72.7174C73.8747 18.7009 77.2857 15.4872 80.3007 13.1304L81.5189 17.2317L82.798 21.6698H87.0008L83.4984 10.7431Z" fill="white"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</aside>

<div class="dashboard__sidebarOverlay" [ngClass]="{ 'open': isOpen }"></div>
